import { useEffect, useState, Fragment } from 'react';
import { useMsal, useAccount } from '@azure/msal-react';
import LoadingPage from '../pages/Loading';
import ErrorPage from '../pages/ErrorPage';
function Auth({ children }) {
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tokenData, setTokenData] = useState(null);

  useEffect(() => {}, [instance, account]);

  useEffect(async () => {
    //refresh web page
    if (account) {
      try {
        const response = await instance.acquireTokenSilent({
          account: account ?? undefined
        });
        setTokenData(response);
        if (response?.idToken) {
          localStorage.setItem('v', response?.idToken);
        } else {
          throw new Error('No token');
        }
      } catch (e) {
        console.log(e);
        setError(e);
      } finally {
        setLoading(false);
      }
    }
  }, [account, instance]);

  if (loading) return <LoadingPage loading={loading} />;

  if (error) return <ErrorPage error={error} />;

  if (tokenData?.tenantId) {
    localStorage.setItem('v', tokenData?.idToken);
    // console.log(tokenData?.idToken);
  }

  return <Fragment>{children}</Fragment>;
}

export default Auth;
